import React from 'react';
import '../../styles/components/Cta.css';

export default function Cta({ name, onClick, transparent, icon, style }) {
    const ctaClass = transparent ? 'cta-btn transparent' : 'cta-btn';
    return (
        <>
            <button className={ctaClass} onClick={onClick} style={{ ...style }}>
                {icon && <span className="cta-icon">{icon}</span>}
                {name}
            </button>
        </>
    );
}
